import * as React from 'react'
import {authenticator} from '../../app/auth/SessionPlusAuthenticator'
import {ReaderFooterPanel} from '../../commons/components/footer/ReaderFooterPanel'
import {MainContainerPanel} from '../../commons/components/main/MainContainerPanel'
import {SettingsPanel} from '../../commons/components/settings/SettingsPanel'
import {ReaderLayout} from '../../commons/layouts/reader-layout/ReaderLayout'
import {ARHeaderPanel} from '../components/header/ARHeaderPanel'
import {ArResourceSection, ArResourcesPanel} from '../components/resources/ArResourcesPanel'

export const ArContentResourcesPage = () => {
  const [showSettings, setShowSettings] = React.useState(false)

  const arHeader = <ARHeaderPanel />
  const arFooter = <ReaderFooterPanel />
  const sections: ArResourceSection[] = [
    {
      id: 'buecher',
      heading: <>Bücher</>,
      filter: (doc) => !doc.properties.skriptum,
    },
  ]

  sections.push({
    id: 'skripten',
    heading: 'VÖGB-Skripten',
    filter: (doc) => Boolean(doc.properties.skriptum),
    linked: authenticator.isAuthenticated(),
  })

  return (
    <ReaderLayout header={arHeader} footer={arFooter} enableScrollTop={true}>
      <MainContainerPanel>
        <ArResourcesPanel sections={sections} />
      </MainContainerPanel>
      <SettingsPanel bottomPosition={false} onToggle={() => setShowSettings(!showSettings)} />
    </ReaderLayout>
  )
}
